/**
 * Aktualizuje CSS třídu HTMLElementu 'data-match-meta-status-update' podle stavu zápasu.
 * CSS třída: 'match-overview-meta__match-status--... (sched | live | fin)'.
 *
 * @param matchElement - HTMLElement - zápas, který má být aktualizován.
 *                       Obsahuje HTMLElement s data atributem: '[data-match-meta-status-update]'
 * @param matchStatus - stav zápasu (např. 'live', 'fin', ...)
 */
export const updateMatchMetaStatus = (
  matchElement: HTMLElement | null,
  matchStatus: string
): void => {
  if (!matchElement) return;

  const matchStatusEl = matchElement.querySelector<HTMLElement>('[data-match-meta-status-update]');
  if (!matchStatusEl) {
    console.warn('Element s [data-match-meta-status-update] nebyl nalezen.');
    return;
  }

  if (
    matchStatusEl.classList.contains('match-overview-meta__match-status--sched') &&
    matchStatus === 'live'
  ) {
    // Prepnutie statusu do 'live'
    matchStatusEl.classList.remove('match-overview-meta__match-status--sched');
    matchStatusEl.classList.add('match-overview-meta__match-status--live');
  } else if (['fin', 'retired'].includes(matchStatus)) {
    // Prepnutie statusu do 'fin'
    matchStatusEl.classList.remove('match-overview-meta__match-status--live');
    matchStatusEl.classList.add('match-overview-meta__match-status--fin');
  }
};
